import LegalDocument from "./LegalDocument";
import { pub } from "@/lib/pubThemeClasses";

export default function Terms() {
  return (
    <LegalDocument eyebrow="Yasal" title="Kullanım Şartları">
      <p className={`font-sans text-sm leading-relaxed ${pub.muted}`}>
        Bu sayfa yer tutucudur. Site ve hizmet kullanımına ilişkin şartlar, sorumluluk sınırları ve iptal süreçleri yakında
        güncellenerek burada yayınlanacaktır.
      </p>
    </LegalDocument>
  );
}
